export const getCssText = (theme, colorScheme) => {
    const colors = theme.colors[colorScheme];
    return Object.entries(colors).reduce((result, [key, value]) => `${result}--bm-color-${key}: ${value};`, '');
};
export const applyTheme = (theme, colorScheme, element) => {
    element.style.cssText = getCssText(theme, colorScheme);
};
//# sourceMappingURL=utils.js.map